/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import { createGlobalStyle } from "styled-components";
import { palette } from "../themes/color-palette";
import { spacing, colors, deviceWidths } from "./variables";

let paddingClasses = "";
for (let i = 1; i <= 20; i += 1) {
  paddingClasses += `
    .horizontal-padding-${i} {
        padding-left: ${spacing}px;
        padding-right: ${spacing}px;
    }
    .vertical-padding-${i} {
        padding-top: ${spacing}px;
        padding-bottom: ${spacing}px;
    }
    .top-padding-${i} {
        padding-top: ${spacing}px;
    }
    .bottom-padding-${i} {
        padding-bottom: ${spacing}px;
    }
    .left-padding-${i} {
        padding-left: ${spacing}px;
    }
    .right-padding-${i} {
        padding-right: ${spacing}px;
    }
    .horizontal-margin-${i} {
        margin-left: ${spacing}px;
        margin-right: ${spacing}px;
    }
    .vertical-margin-${i} {
        margin-top: ${spacing}px;
        margin-bottom: ${spacing}px;
    }
    .top-margin-${i} {
        margin-top: ${spacing}px;
    }
    .bottom-margin-${i} {
        margin-bottom: ${spacing}px;
    }
    .left-margin-${i} {
        margin-left: ${spacing}px;
    }
    .right-margin-${i} {
        margin-right: ${spacing}px;
    }
`;
}

export const GlobalStyles = createGlobalStyle`
    html {
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
    }

    *, *:before, *:after {
        -webkit-box-sizing: inherit;
        box-sizing: inherit;
    }

    html, body {
        height: 100%;
        font-family: 'Raleway', sans-serif;;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #333;
        font-size: 16px;
    }

    a {
        text-decoration: none;
    }

    ul {
        margin-block-start: 0;
        margin-block-end: 0;
        padding-inline-start: 18px;
        font-size: 16px;
        line-height: 24px;
    }

    .min-height {
        position: relative;
        height: 100%;

        @media (max-width: 959px) {
            height: auto;
        }
    }

    .min-device-height {
        min-height: 100vh;
    }

    .min-content-height {
        min-height: calc(100vh - 60px);

        &:not(.login-form) {
            @media  (max-width: 959px) {
                min-height: auto;
            }
        }
    }

    #root {
        min-height: 100vh;
    }
    
    .MuiSwitch-thumb,
    .MuiPopover-paper {
        box-shadow: 0px 1px 4px 2px rgb(0 0 0 / 15%), 0px 2px 1px 0px rgb(0 0 0 / 9%);
    }

    .MuiSwitch-root + .MuiTypography-root {
        color: ${colors.blue};
        font-weight: 500;
    }

    .MuiDialogContent-root {
        padding: 24px;
    }
    .alert-msg-margin{
        margin-top: 5%;
    }
 
    .store-selelction-msg {
        font-weight: normal;
        font-size: 16px;
        line-height: 14px;
        margin-right: 15.5%;
    }

    .customer-search {
        font-weight: bold;
        font-size: 18px;
        line-height: 24px;
        color: ${palette.border.main};
    }
    .customer-create {
        display: flex;
        alignment: center;
        color: ${palette.border.main};
    }
    .custom-flex-basis {
    flex-grow: 0;
    max-width: 50%;
    flex-basis: 30%;
    }
    ${paddingClasses}
    .mostSearched_container{
        &-yellow{
            background-color: rgba(230, 115, 0, 0.06);
            .item_searchs{
                color :#E67300;
                background-color: rgba(230, 115, 0, 0.1);
    
            }
            .item_position{
                color: white;
                background-color:#E67300
            }
        }
        &-blue{
            background-color: rgba(17, 144, 224, 0.06);
            .item_searchs{
                color:#1190E0;
                background-color: rgba(17, 144, 224, 0.1)
            }
            .item_position{
                color: white;
                background-color:#1190E0
            }
        }

    }
    .dashboardChart_container{
        box-shadow: 0px 0px 6px #0000001a;
        border-radius: 8px;
        padding: 2em;
        margin-top:2em;
    }

    // Label  de  inputs  de formulario
    .formSearch__label-text {
        font-weight: bold;
        color: black;
        font-size: 12px;
        padding: 0px 0px 8px 0px; 
        & .white {
            color: white;
            font-size: 1.5rem;
        }
        & .red {
            color: red;
            font-size: 1.5rem;
        }
    }
    //fin label del inputs de formulario

    .mt-1{
        margin-top: 1rem;
    }
    .mt-2{
        margin-top: 2em;
    }
    .mb-1{
        margin-bottom: 1rem;
    }

    .pointer{
        cursor: pointer;
    }


    //Radio button group

    .radio__group{
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: flex-end;
        flex-wrap: nowrap;
        padding-left: 10px;
        justify-content: space-between
    }
    .fixed-radio{
        width: 305px !important;
    }

    .radioButton__border{
        border: solid 2px #dcdcdc;
        border-radius: 25px;
        padding-right: 5px;
        margin-right: 15px;
        font-size: 10px;
        height: 40px;
        width: 60%;
        font-size:8px ;

        .MuiTypography-root{
            font-size: 12px;
            overflow: hidden;
        }
    }

    .radioButton__border-active{
        border: solid 2px #8a000b;
        border-radius: 25px;
        padding-right: 15px;
        font-size: 10px;
        height: 40px;
        width: 60%;
        font-size:8px ;
        
        .MuiTypography-root{
            font-size:12px ; 
            overflow:hidden ;
            text-overflow: ellipsis;
        }
    }


    //Caja de select
    .caja-form {
        width: 293px;
        padding: 20px 10px 0px 0px;
    }

    .card-style {
        width: 290px;
        padding: 20px 10px 20px 5px;
    }

    .button-export {
        border-radius: 25px;
        border: 1px solid #8A000B;
        padding: 0.5em 1.5em;
    }

    .order-report-container {
        text-align: right;
    }

    .order-report-container button {
        background-color: white;
        color: #600007;
    }

    .order-report-modal {
        width: 500px;
    }
    
    .exportButtonGrid{
        @media   ${deviceWidths.xs} {
            justify-content:center;
            margin: 20px 0;
        }
        @media   ${deviceWidths.md} {
            width: calc(20vw);
            display: flex;
            justify-content:flex-end;
        }

    }
    .helperError {
        margin: 0;
        font-size: 13px;
        margin-left: 14px;
        margin-right: 14px;
        margin-top: 4px;
        text-align: left;
        font-family: Raleway, sans-serif;
        font-weight: 400;
        line-height: 1.66;
        color: #f44336;
      }

      .hide {
  display: none;
}

.imgHover:hover + .hide {
  display: block;

}

 .red-required {
    color: red;
    font-size: 1.3rem;
    margin: 0;
}

.button_wrapper{
    display: flex;
    align-items: flex-end;
    padding-bottom: 12px !important;
    &-variant{
      display: flex;
      align-items: center;
    }
}

.red-required-label{
    color:  red;
    font-size:  12px;
    font-weight: bolder;
    span{
        font-size: 24px;
    }
}
#popup-detail{
    overflow-y: auto;
    height: 100%;
}
`;
